const EmailList = r => require.ensure([], () => r(require('./EmailList.vue')), 'shared')

export default EmailList
